import Vue from 'vue';
import Vuesax from 'vuesax';
import App from './app.vue';
import store from './store';
import router from './router';

Vue.use(Vuesax);
Vue.config.productionTip = false;

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    try {
      await store.dispatch('getCurrentUser');
      await store.dispatch('getOrders');

      next();
    } catch (_) {
      next({ path: '/sign-in' });
    }
  } else {
    next();
  }
});

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
